import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Product(props) {
  const productList = [
    {
      id: 1,
      name: "普通高考升学班",
      desc: "圆你大学梦",
      btnText: "定制方案",
    },
    {
      id: 2,
      name: "职普融通升学班",
      desc: "上理想本科",
      btnText: "获取简章",
    },
    {
      id: 3,
      name: "艺考专业升学班",
      desc: "考艺术院校",
      btnText: "咨询学费",
    },
    {
      id: 4,
      name: "职教高考升学班",
      desc: "升对口本科",
      btnText: "抢占名额",
    },
    {
      id: 5,
      name: "单招培训升学班",
      desc: "助升学之路",
      btnText: "点击咨询",
    },
  ]

  return (
    <section className={styles["product-container"]}>
      <h3 className="section__title">多元化升学班型</h3>
      <div className="section__inner">
        <ul className={classnames("product-list", "clearfix")}>
          {productList.map((model) => {
            return (
              <li className={styles["product-item"]} key={model.id}>
                <h4>{model.name}</h4>
                <p>{model.desc}</p>
                <button
                  className={styles["product-btn"]}
                  onClick={() => {
                    window.openJesongChatByGroup(121, 52601)
                    return false
                  }}
                >
                  {model.btnText}
                </button>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Product
